import React,{useEffect} from 'react'
import './InnerPrivacyPolicy.css'
import OrangeFilledRoundBtn from '../../Common-Component/Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn'
import YellowFilledRoundBtn from '../../Common-Component/Common_Btn/YellowFilledRoundBtn/YellowFilledRoundBtn'
import { useDispatch, useSelector } from "react-redux";
import { getPrivacy_Policy } from '../../../features/privacypolicy/Slice';
import parse from "html-react-parser";

const InnerPrivacyPolicy = () => {

    const privacypolicy = useSelector((state) => state.privacypolicy.addPrivacyPolicy);
    const dispatch = useDispatch();
 

   useEffect(() => {
         dispatch(getPrivacy_Policy());
       }, [dispatch]);
  
    return (
        <section className='InnerPolicy'>
            <p className='policy_decsn_text'>  {privacypolicy.description ? parse(privacypolicy.description) : ""}</p>

            {/* <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a
                type specimen book. It has survived not only five centuries, but also the leap into electronic types- etting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
                Aldu PageMaker including versions of Lorem Ipsum.
            </p>

            <p className='policy_light_heading'>1. WHAT INFORMATION WE COLLECT</p>

            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a
                type specimen book. It has survived not only five centuries, but also the leap into electronic types- etting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
                Aldu PageMaker including versions of Lorem Ipsum.
            </p>

            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a
                type specimen book. It has survived not only five centuries, but also the leap into electronic types- etting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
                Aldu PageMaker including versions of Lorem Ipsum.
            </p>

            <p className='policy_light_heading'>2. ACCESS TO & CHOICES ABOUT YOUR INFORMATION</p>

            <p className='policy_decsn_text'>
                You have the option to: (1) opt out of receiving promotional materials via mail, phone, or email; (2) access, review, verify, update, or rectify your personal Information; or (3) deactivate your account. To exercise any of these options, just get in touch with MCW, as detailed herein. You can unsubscribe from marketing emails by visiting the Communication Preferences page.
            </p>


            <p className='policy_light_heading'>3. SECURITY</p>


            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a
                type specimen book. It has survived not only five centuries, but also the leap into electronic types- etting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
                Aldu PageMaker including versions of Lorem Ipsum.
            </p>

            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a
                type specimen book. It has survived not only five centuries, but also the leap into electronic types- etting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
                Aldu PageMaker including versions of Lorem Ipsum.
            </p> */}

            {/* <div className='footer_btn_holder'>
                    <div className='yellow_btn_holder'>
                    <YellowFilledRoundBtn btnText={"Decline"}/>
                    </div>

                    <div className='orange_btn_holder'>
                        <OrangeFilledRoundBtn btnText={"Accept"}/>
                    </div>
            </div> */}

        </section>
    )
}

export default InnerPrivacyPolicy
